import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import MoneyIcon from '@material-ui/icons/Money';
import { orange } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';

const Budget = (props) => {
  const navigate = useNavigate();
  const { value } = props;

  const viewOrders = () => {
    navigate('/app/orders/status/WB', { replace: true });
  };
  return (
    <Card
      sx={{ height: '100%' }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              Ordens Aguardando
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              { value.waiting}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56
              }}
            >
              <MoneyIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          sx={{
            pt: 2,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Button onClick={viewOrders}>Ver todas</Button>
        </Box>
      </CardContent>
    </Card>
  );
};

Budget.propTypes = {
  value: PropTypes.object.isRequired,
};

export default Budget;
